import HTTPClient from './http-client';

const END_POINT = '/climatologicalaverage';

const options = {
  cache: {
    maxAge: 5 * 60 * 1000,
    exclude: { query: false }
  }
}

const loadClimatographicAverage = async (month, variable, location_id) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?month=${month}&variable=${variable}&location_ids=${location_id}`,
    options
  );
}

export {
  loadClimatographicAverage
}
